import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Paper } from '@mui/material';
import classnames from 'classnames';
import { useScrollbarStyles } from 'modules/common/styles/useScrollbarStyles';
import { CopyrightFooter } from 'modules/common/components/CopyrightFooter';
import SupervisorHeader from './headers/SupervisorHeader';
import SupervisorInsights from './Notes/SupervisorInsights';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 'unset',
    backgroundColor: theme.palette.information.pageBackground,
    width: '100%'
  }
}));

const SuperVisorPage: React.FC = () => {
  const classesScrollbar = useScrollbarStyles();
  const classes = useStyles();
  return (
    <Paper
      className={classnames(classes.root, classesScrollbar.scrollbar)}
      square
      elevation={0}
      data-testid="insights-supervisor-page"
    >
      <SupervisorHeader />
      <SupervisorInsights />

      <Grid container justifyContent={'center'}>
        <CopyrightFooter />
      </Grid>
    </Paper>
  );
};

export default memo(SuperVisorPage);
